module.exports = __webpack_public_path__ + "static/media/3.fbe22c3a.gif";